// extracted by mini-css-extract-plugin
export var createdDate = "_nl-1";
export var divider = "_nl-2";
export var headerDivider = "_nl-3";
export var messagesCard = "_nl-0";
export var messagesContainer = "_nl-7";
export var messagesContainerWrapper = "_nl-4";
export var pointerCapturingButtonBoxes = "_nl-a";
export var showLeftPanelButton = "_nl-9";
export var showMoreButton = "_nl-c";
export var showMoreButtonContainer = "_nl-b";
export var summaryTitle = "_nl-6";
export var systemMessageCardWrapper = "_nl-d";
export var topButtons = "_nl-8";
export var withPadding = "_nl-5";